import apiClient from '../apiClient';
import { Route } from '../routes/route.vm';
import { mapStageCollectionFromApiToVm, mapStageFromApiToVm } from './stage.mapper';
import * as vm from './stage.vm';

export const stagesService = {
  getStages: async () => {
    const response = await apiClient.get('/stages');
    return mapStageCollectionFromApiToVm(response.data);
  },

  getStage: async (id: vm.Stage['id']) => {
    if (!id) {
      throw new Error('Stage Id not provided');
    }
    const response = await apiClient.get(`/stages/${id}`);
    return mapStageFromApiToVm(response.data);
  },

  getStagesByRoute: async (routeId: Route['id']) => {
    if (!routeId) {
      throw new Error('Route Id not provided');
    }
    const response = await apiClient.get(`/stages`, {
      params: { routeId },
    });
    return mapStageCollectionFromApiToVm(response.data);
  },

  createStage: async (stage: FormData) => {
    if (!stage) {
      throw new Error('Stage not provided');
    }
    try {
      const response = await apiClient.post('/stages', stage, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return mapStageFromApiToVm(response.data);
    } catch (e) {
      throw new Error('Failed to create stage');
    }
  },

  updateStage: async (stageId:  vm.Stage['id'], stage: FormData) => {
    if (!stageId) {
      throw new Error('Stage Id not provided');
    }
    if (!stage) {
      throw new Error('Stage data not provided');
    }
    try {
      const response = await apiClient.patch(`/stages/${stageId}`, stage, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return mapStageFromApiToVm(response.data);
    } catch (e) {
      throw new Error('Failed to update stage');
    }
  },

  deleteStage: async (stageId:  vm.Stage['id']) => {
    if (!stageId) {
      throw new Error('Stage Id not provided');
    }
    try {
      const response = await apiClient.delete(`/stages/${stageId}`);
      return response.data;
    } catch (e) {
      throw new Error('Failed to delete stage');
    }
  },

  reorder: async (newStagesOrdering: Array<{ stageId: vm.Stage['id']; newOrder: number }>) => {
    if (!newStagesOrdering) {
      throw new Error('New stages ordering not provided');
    }
    try {
      const response = await apiClient.patch(`/stages/reorder`, { stages: newStagesOrdering });
      return response.data;
    } catch (e) {
      throw new Error('Failed to reorder');
    }
  },
};
